export const githubAppClientId = "Iv1.395428b4814a0264";
export const oauthAppClientId = "85a27bfae82f55b624f1";
